import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';  

const TokenChecker = () => {
  const navigate = useNavigate();  

  useEffect(() => {
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("jwt_j");
      const timestamp = localStorage.getItem("loginTime");

      if (token && timestamp) {
        const currentTime = new Date().getTime();
        const timeDifference = currentTime - timestamp; 
        // const expirationTime = 30 * 1000; // 30 seconds in milliseconds
        const expirationTime = 20 * 60 * 1000; // 20 minute in milliseconds
        // If the token is expired, remove it from localStorage
        if (timeDifference > expirationTime) {
          localStorage.removeItem("jwt_j");
          localStorage.removeItem("access_token");
          localStorage.removeItem("loginTime");
          console.log("Token expired and removed.");
        }
      } 
    };

    checkTokenExpiration();
  }, [navigate]); 

  return null; 
};
export default TokenChecker;
